import React, { useState } from 'react';
import { supabase } from '../supabase';

export default function ConfigurarContrasena({ onListo }) {
  const [pass, setPass]         = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [error, setError]       = useState('');

  async function guardar() {
    setError('');
    if (pass.length < 6)          { setError('La contraseña debe tener al menos 6 caracteres.'); return; }
    if (pass !== confirmar)        { setError('Las contraseñas no coinciden.'); return; }

    setGuardando(true);
    const { data: { user } } = await supabase.auth.getUser();

    // DB primero: si auth dispara onAuthStateChange antes de que terminemos,
    // el re-fetch del perfil ya encontrará contrasena_configurada=true
    await supabase.from('profiles').update({ contrasena_configurada: true }).eq('id', user.id);

    const { error: authErr } = await supabase.auth.updateUser({ password: pass });
    if (authErr) {
      // Revertir si auth falla
      await supabase.from('profiles').update({ contrasena_configurada: false }).eq('id', user.id);
      setError('Error: ' + authErr.message);
      setGuardando(false);
      return;
    }

    setGuardando(false);
    onListo();
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--surface)', border: '0.5px solid var(--border)',
        borderRadius: 14, padding: '36px 32px', maxWidth: 400, width: '90%',
        boxShadow: '0 12px 40px rgba(0,0,0,0.22)',
      }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>
          Configurá tu contraseña
        </div>
        <div style={{ fontSize: 13, color: 'var(--text4)', marginBottom: 24, lineHeight: 1.5 }}>
          Es la primera vez que ingresás. Creá una contraseña para poder acceder al estudio en el futuro sin necesitar un link por email.
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', display: 'block', marginBottom: 4 }}>
              Nueva contraseña
            </label>
            <input
              type="password"
              className="form-input"
              placeholder="Mínimo 6 caracteres"
              value={pass}
              onChange={e => setPass(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && guardar()}
              autoFocus
            />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', display: 'block', marginBottom: 4 }}>
              Confirmar contraseña
            </label>
            <input
              type="password"
              className="form-input"
              placeholder="Repetí la contraseña"
              value={confirmar}
              onChange={e => setConfirmar(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && guardar()}
            />
          </div>
        </div>

        {error && (
          <div style={{ marginTop: 12, fontSize: 12, color: '#dc2626', background: '#fef2f2', border: '0.5px solid #fecaca', borderRadius: 6, padding: '8px 12px' }}>
            {error}
          </div>
        )}

        <button
          className="btn btn-primary"
          onClick={guardar}
          disabled={guardando || !pass || !confirmar}
          style={{ width: '100%', marginTop: 20, padding: '11px' }}
        >
          {guardando ? 'Guardando…' : 'Guardar contraseña'}
        </button>
      </div>
    </div>
  );
}
